function removeHtmlTags(stringWithHtml: string) {
  let regex = /(<([^>]+)>)/gi;
  return stringWithHtml.replace(regex, "");
}

export { removeHtmlTags };
